// Archivo de entorno para Desarrollo
// Este archivo se usa para pruebas locales con configuración de desarrollo

export const environment = {
  production: false,
  apiUrl: 'https://tmp.myservy.com',
  baseUrl: 'https://rf-sit.myservy.com/login',
  version: '1.0.7-dev',
  name: 'development',
  debug: true,
  logLevel: 'debug',
  enableAnalytics: false,
  firebase: {
    apiKey: 'AIzaSyCP4besEb7Kq6FLu5rlR4c_23vPYlpusG0',
    authDomain: 'riskyiddev.firebaseapp.com',
    projectId: 'riskyiddev',
    storageBucket: 'riskyiddev.firebasestorage.app',
    messagingSenderId: '1047381331954',
    appId: '1:1047381331954:web:38286f5d0a64442526256b',
  },
};
